import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  from
} from '@apollo/client';
import { authLink } from './authLink';
import { errorLink } from './errorLink';

const httpLink = createHttpLink({
  uri: /localhost$/.test(location.hostname)
    ? '/graphql'
    : `${process.env.REACT_APP_BACKEND_API_BASE_URL}/graphql`
});

const pusherLink = createHttpLink({
  uri: /localhost$/.test(location.hostname)
    ? '/pusher/learner-auth'
    : `${process.env.REACT_APP_BACKEND_API_BASE_URL}/pusher/learner-auth`
});

export const client = new ApolloClient({
  link: from([errorLink, authLink, httpLink, pusherLink]),
  cache: new InMemoryCache()
});
